export const addEventRequested = () => ({ type: 'ADD_EVENT_REQUESTED' })
export const getEventsRequested = () => ({ type: 'GET_EVENTS_REQUESTED' })

export const addEventSuccess: any = data => ({
  type: 'ADD_EVENT_SUCCESS',
  payload: data
})

export const addEventError: any = data => ({
  type: 'ADD_EVENT_ERROR',
  payload: data
})

export const getEventsSuccess: any = data => ({
  type: 'GET_EVENTS_SUCCESS',
  payload: data
})

export const getEventsError: any = data => ({
  type: 'GET_EVENTS_ERROR',
  payload: data
})

export const showDetails: any = data => ({
  type: 'SET_EVENT_DETAILS',
  payload: data
})

export const closeDetails: any = () => ({
  type: 'CLOSE_EVENT_DETAILS'
})
